import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { deleteCalibration } from '../../../../store/apis/calibrationService';

function DeleteCalibrationModal({
  isOpen,
  toggle,
  refetchCalibrationDetails,
  toDeleteSessionId,
  setToDeleteSessionId,
}) {
  const { mutate: deleteCalibrationData } = useMutation({
    mutationFn: deleteCalibration,
    onSuccess: () => {
      toast.success('Calibration Session deleted successfully!', {
        className: 'toast-success',
      });
      setToDeleteSessionId(null);
      toggle();
      refetchCalibrationDetails();
    },
    onError: error => {
      toast.error(error?.message || 'Failed to delete Calibration', {
        className: 'toast-error',
      });
      setToDeleteSessionId(null);
      toggle();
    },
  });

  const onDelete = () => {
    if (!toDeleteSessionId) {
      toast.error('No Calibration Session selected for deletion', {
        className: 'toast-error',
      });
      return;
    }
    const payload = {
      sessionId: toDeleteSessionId,
    };
    deleteCalibrationData(payload);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      modalClassName="custom-modal-size"
      centered
      backdrop="static"
      keyboard={false}
    >
      <ModalHeader toggle={toggle}>Confirm Submission</ModalHeader>
      <ModalBody>
        Are you sure you want to cancel this Calibration Session?
      </ModalBody>
      <ModalFooter className="modalFooter">
        <Button className="item custom-light-btn" onClick={toggle}>
          No
        </Button>
        <Button
          className="item custom-btn"
          onClick={() => {
            onDelete();
          }}
        >
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default DeleteCalibrationModal;
